export const ABOUT_SECTIONS = [
    { id: 'position', index: '01', label: 'Position' },
    { id: 'practice', index: '02', label: 'Practice' },
    { id: 'method', index: '03', label: 'Method' },
    { id: 'colophon', index: '04', label: 'Colophon' }
]

export const ABOUT_SECTION_IDS = ABOUT_SECTIONS.map(section => section.id)

export const PRACTICE = [
    {
        index: '01',
        label: 'Identity',
        note: 'Marks, systems, and the rules that keep them honest.',
        count: '24 projects'
    },
    {
        index: '02',
        label: 'Typeface design',
        note: 'Retail and commissioned families, drawn in-house.',
        count: '9 families'
    },
    {
        index: '03',
        label: 'Editorial',
        note: 'Books, monographs, catalogues, and the odd annual report.',
        count: '31 titles'
    },
    {
        index: '04',
        label: 'Wayfinding',
        note: 'Signage systems for transit, civic and cultural clients.',
        count: '6 systems'
    },
    {
        index: '05',
        label: 'Packaging',
        note: 'Structure and surface, produced with the printer in the room.',
        count: '18 lines'
    },
    {
        index: '06',
        label: 'Interface',
        note: 'Reading, browsing, buying. Screens that hold still.',
        count: '14 products'
    }
]

export const METHOD = [
    {
        index: '01',
        title: 'Read',
        body: 'Before anything is drawn we read everything: the brief, the archive, the complaints, the competition. Most of what a project needs is already written down somewhere by someone who was annoyed.'
    },
    {
        index: '02',
        title: 'Draw',
        body: 'We draw far more than we show. The work you see is the third or fourth position, and it survives because it beat the others in the room, not because it arrived first.'
    },
    {
        index: '03',
        title: 'Prove',
        body: 'Nothing leaves the studio untested. Type gets proofed on paper, signage gets printed at size and taped to a wall, interfaces get handed to someone who did not make them.'
    }
]

export const COLOPHON = [
    { term: 'Founded', value: '2016, in a former print works' },
    { term: 'Studio', value: 'London SE16 · Lisbon' },
    { term: 'People', value: 'Nine, plus a dog' },
    { term: 'Sectors', value: 'Transport, publishing, coffee, cosmetics' },
    { term: 'Recognition', value: 'D&AD, TDC and ADC — twelve times' },
    { term: 'Intake', value: 'Roughly six projects a year' }
]
